(function () {
  // Waitlist: use Shopify's own form submission. Shopify saves the customer, runs its spam check if needed,
  // and reloads the page with ?customer_posted=true, where the form shows its thank-you message.
  // Here we only stop double submissions and bring the confirmed form back into view.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('waitlist')) return;
    if (form.dataset.submitting === 'true') { e.preventDefault(); return; }
    form.dataset.submitting = 'true';
    var button = form.querySelector('button[type="submit"]');
    if (button) {
      // defer so the browser has already captured the form data before the button changes
      setTimeout(function () { button.disabled = true; button.textContent = 'Joining…'; }, 0);
    }
  });

  if (/customer_posted=true/.test(window.location.search)) {
    var target = window.location.hash ? document.querySelector(window.location.hash) : null;
    if (!target) target = document.querySelector('.waitlist__done');
    if (target) target.scrollIntoView({ block: 'center' });
  }

  // If the visitor comes back with the browser's Back button, re-enable the form.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form.waitlist[data-submitting="true"]').forEach(function (form) {
      form.dataset.submitting = 'false';
      var button = form.querySelector('button[type="submit"]');
      if (button) { button.disabled = false; button.textContent = button.getAttribute('data-label') || 'Join the list'; }
    });
  });
})();
